<template>
  <div id="hallbuilder" v-bind:class="{'inactive': activated === false}" :style="cssVars">
    <button id="activate" v-on:click="activate()">Börja bygga</button>
    <div class="viewport-switcher">
      <button v-bind:class="{'not-active': viewport === 'rear'}" v-on:click="viewport = 'front'">Framsida</button>
      <button v-bind:class="{'not-active': viewport === 'front'}" v-on:click="viewport = 'rear'">Baksida</button>
    </div>
    <transition appear name="shift">
      <div class="viewport left-front" v-if="viewport == 'front'">
        <!-- <h1>Framsida</h1> -->
        <div class="hall view-front">
          <div class="sections">
            <div class="roof" v-bind:style="roofStyle">
              <div class="seam seam-1" v-if="gableSize === 12"><div class="seam-inner"></div></div>
              <div class="seam seam-2" v-if="gableSize === 18"><div class="seam-inner"></div></div>
              <div class="seam seam-3" v-if="gableSize === 18"><div class="seam-inner"></div></div>
              <div class="roof-inner" v-bind:class="roofOverhang">
              </div>
            </div>
            <div class="gable" v-bind:data-gablesize="gableSize">
              <HallSection v-for="section in sections.left" v-bind:key="section.id" :sectiondata="section" :height="sectionHeight"></HallSection>

              <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement">{{ gableSize }}m</div>
            </div>
            <HallSection v-for="section in sections.front" v-bind:key="section.id" :sectiondata="section" :height="sectionHeight"></HallSection>
            <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement length">{{ sections.front.length * 6 }}m</div>
            <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement height">{{ sectionHeightDisplay }}m</div>
            <div class="floor" v-bind:style="roofStyle"></div>
          </div>
        </div>
      </div>
    </transition>
    <transition appear name="shift">
      <div class="viewport right-rear" v-if="viewport == 'rear'">
        <!-- <h1>Baksida</h1> -->
        <div class="hall view-rear">
          <div class="sections">
            <div class="roof" v-bind:style="roofStyle">
              <div class="seam seam-1" v-if="gableSize === 12"><div class="seam-inner"></div></div>
              <div class="seam seam-2" v-if="gableSize === 18"><div class="seam-inner"></div></div>
              <div class="seam seam-3" v-if="gableSize === 18"><div class="seam-inner"></div></div>
              <div class="roof-inner" v-bind:class="roofOverhang"></div>
            </div>
            <div class="gable" v-bind:data-gablesize="gableSize">
              <HallSection v-for="section in sections.right" v-bind:key="section.id" :sectiondata="section" :height="sectionHeight"></HallSection>
              <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement">{{ gableSize }}m</div>
            </div>
            <HallSection v-for="section in sections.rear" v-bind:key="section.id" :sectiondata="section" :height="sectionHeight"></HallSection>
            <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement length">{{ sections.rear.length * 6 }}m</div>
            <div v-bind:style="{fontSize: oneMeter * 1.75 + 'px'}" class="measurement height">{{ sectionHeightDisplay }}m</div>
            <div class="floor" v-bind:style="roofStyle"></div>
          </div>
        </div>
      </div>
    </transition>
    <transition appear name="fadeup">
      <Configuration class="section-settings" :section="configuringSection" v-if="configuringSection != false">
      </Configuration>
    </transition>

    <div 
    class="inputs"
    v-bind:data-visible="settingsVisible"
    >
      <div class="header">
        <h2 >Utformning</h2>
        <button class="close" v-on:click="settingsVisible = !settingsVisible"></button>
      </div>
      <div class="inner">
        <div class="fields">
          <div class="field">
            <h3>
              <label for="ground">Underlag</label>
              <div class="buttons align-left">
                <button v-on:click="mainBg = ''" class="padded" style="background-color: rgb(255,255,255);"></button>
                <button v-on:click="mainBg = 'tarmac'" class="padded" style="background: url('tarmac-perspective.jpg');"></button>
                <button v-on:click="mainBg = 'grass'" class="padded" style="background: url('grass.jpg');"></button>
              </div>
            </h3>
          </div>
          <div class="field">
            <div class="field-content">
              <h3>
                <label for="">Hallens längd: </label><span class="value">{{ sections.rear.length * 6 }} meter</span>
                <button class="uppercase icon-plus" v-if="sections.rear.length < 10" v-on:click="addSection"><span></span></button>
              </h3>

              <br>
              <h3><label for="">Välj till: </label><span class="value">Dörrar, fönster etc.</span></h3>
              <div class="buttons two-cols two-actions" v-if="viewport == 'front'">
                <span 
                v-for="(section, i) in sections.front"
                v-bind:key="section.id" 
                >
                  <button
                  class="icon-wrench"
                  v-on:click="configuringSection = section"
                  @mouseover="highlightSection( section )"
                  @mouseleave="dimSection(section)"
                  >Sektion {{ i + 1 }}
                  </button>
                  <button
                  class="deletes"
                  v-on:click="removeSection(section)"
                  v-if="sections.front.length > minSectionCount"
                  >&times;</button>
                </span>
              </div>
              <div class="buttons two-cols two-actions" v-if="viewport == 'rear'">
                <span 
                v-for="(section, i) in sections.rear"
                v-bind:key="section.id" 
                >
                  <button 
                  class="icon-wrench"
                  v-on:click="configuringSection = section"
                  @mouseover="highlightSection( section )"
                  @mouseleave="dimSection(section)"
                  >Sektion {{ i + 1 }}
                  </button>
                  <button
                  class="deletes"
                  v-on:click="removeSection(section)"
                  v-if="sections.rear.length > minSectionCount"
                  >&times;</button>
                </span>
              </div>
            </div>

          </div>
          <hr>
          <div class="field">
            <div class="field-content">
              <h3>
                <label for="">Hallens bredd: </label><span class="value">{{ gableSize }} meter</span>
                <button class="uppercase icon-plus" v-if="sections.left.length === 2" v-on:click="addGableSection()"><span></span></button>
              </h3>
                <!-- <p class="small" v-if="sections.left.length === 3"><em>Maximal bredd uppnådd, men det går faktiskt att bygga bredare hallar. <br><a target="_blank" href="https://www.actmb.se/kontakt/">Kontakta oss</a> så berättar vi mer!</em></p> -->
              <br>
              <h3><label for="">Välj till: </label><span class="value">Dörrar, fönster etc.</span></h3>
              <div class="buttons two-cols two-actions" v-if="viewport == 'front'">
                <span
                v-for="(section, i) in sections.left" 
                v-bind:key="section.id" 
                >
                  <button 
                  class="icon-wrench"
                  v-on:click="configuringSection = section"
                  @mouseover="highlightSection( section )"
                  @mouseleave="dimSection(section)"
                  >Sektion {{ i + 1 }}</button>
                  
                  <button
                  class="deletes"
                  v-on:click="removeSection(section)"
                  v-if="gableSize == 18"
                  >&times;</button>
                </span>
              </div>

              <div class="buttons two-cols two-actions" v-if="viewport == 'rear'">
                <span
                v-for="(section, i) in sections.right" 
                v-bind:key="section.id" 
                >
                  <button 
                  class="icon-wrench"
                  v-on:click="configuringSection = section"
                  @mouseover="highlightSection( section )"
                  @mouseleave="dimSection(section)"
                  >Sektion {{ i + 1 }}</button>
                  <button
                  class="deletes"
                  v-on:click="removeSection(section)"
                  v-if="gableSize == 18"
                  >&times;</button>
                </span>
              </div>
              
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-content">
            <h3><label for="base-material">Sockel</label></h3>
            <div class="buttons fullwidth align-left text-small">
              <button v-on:click="baseMaterial = 'default'">Nej</button>
              <button v-on:click="baseMaterial = 'concrete'">Betong</button>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-content">
            <h3><label for="color">Färg: </label><span class="value">Tak</span></h3>
            <div class="buttons align-left">
              <button 
                class="padded"
                v-bind:style="{backgroundColor: color}"
                v-for="color in roofPalette" 
                v-bind:key="color" 
                v-on:click="roofColor = color">
              </button>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-content">
            <h3><label for="roof-overhang">Takutsprång</label></h3>
            <div class="buttons fullwidth align-left text-small">
              <button v-on:click="roofOverhang = 'none'">Nej</button>
              <button v-on:click="roofOverhang = 'overhang'">Ja</button>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-content">
            <h3><label for="">Färg: </label><span class="value">Väggar</span></h3>
            <div class="buttons align-left">
              <button 
              class="padded"
              v-bind:style="{backgroundColor: color.color}"
              v-for="color in palette" 
              v-bind:key="color.color" 
              v-on:click="baseColor = color">
              </button>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-content borderless">
            <h3><label for="">Färg: </label><span class="value">Rand</span></h3>
            <div class="buttons align-left">
              <button 
              class="padded"
              v-bind:style="{backgroundColor: color.color}"
              v-for="color in palette" 
              v-bind:key="color.color" 
              v-on:click="complementaryColor = color">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-step-panel share-panel" v-if="currentPanel == 'share'">
      <h3>Dela din hall 
      <button 
        v-on:click="currentPanel = ''" 
        class="small close"
        ></button></h3>
      <label for="">Dela länk</label>
      <input type="text" v-model="shareurl">

      <label>Dela via e-post</label>
      <div class="relative">
        <input type="email" placeholder="E-postadress att skicka till" name="email" v-model="recipientEmail">
        <button 
        v-if="recipientEmail != ''"
        v-on:click="sendByEmail"
        >Skicka</button>
      </div>
    </div>
    <div class="next-step-panel quote-panel" v-if="currentPanel == 'quote'">
      <h3>Få en offert 
      <button 
      v-on:click="currentPanel = ''" 
      class="small close"
      ></button></h3>
      <div>
        <div class="relative">
          <input type="email" placeholder="Din e-postadress" name="email" v-model="quoteRecipientEmail">
          <input type="text" placeholder="Ditt telefonnummer" name="phone" v-model="quoteRecipientPhone">
          <textarea placeholder="Ytterligare information" v-model="quoteComment"></textarea>
          <button 
          v-if="quoteRecipientEmail != ''"
          v-on:click="sendQuoteRequest"
          >Begär offert</button>
        </div>
      </div>
    </div>
    <div class="next-step-panel contact-panel" v-if="currentPanel == 'contact'">
      <h3>Kontakt 
      <button 
        v-on:click="currentPanel = ''" 
        class="small close"
        ></button></h3>
      <p>
        <strong>ACT M&B AB</strong><br>
        <a href="mailto:info@actmb.se">info@actmb.se</a><br>
        <a class="phone" href="tel:0101779930">010 – 177 99 30</a>
      </p>
    </div>
    <div class="next-steps-panel">
      <button
      v-on:click="currentPanel = 'share'"
      class="small"
      >Dela din hall</button>
      <button
      v-on:click="currentPanel = 'quote'"
      class="small"
      >Få en offert</button>
      <button
      v-on:click="currentPanel = 'contact'"
      class="small"
      >Kontakt</button>
    </div>
    <div class="spec-panel">
      <p v-if="squareMeters !== 0" class="price-output">{{ parseInt( squareMetersTween, 10 ) }}m<sup>2</sup></p>
    </div>

    <SpecificationPanel :html="specificationHtml"></SpecificationPanel>
    <!-- <div class="full-specification" v-html="specificationHtml"></div> -->
  </div>
</template>

<script>
import HallSection from '@/components/HallSection.vue'
import Configuration from '@/components/Configuration.vue'
import SpecificationPanel from '@/components/SpecificationPanel.vue'
import VueMixinTween from 'vue-mixin-tween';
import axios from 'axios';

export default {
  name: 'HallBuilder',
  components: {
    HallSection,
    Configuration,
    SpecificationPanel
  },
  data: function(){
    return {
      activated: false,
      calculationId: false,
      cooldown: false,
      viewport: 'front',
      recipientEmail: '',
      quoteRecipientEmail: '',
      quoteRecipientPhone: '',
      quoteComment: '',
      configuringSection: false,
      settingsVisible: true,
      calculatedTotal: 0,
      gableStyle:'',
      gableSize: 12,
      jsonSummary: {},
      jsonStringInput: '',
      mainBg: '',
      minSectionCount: 3,
      baseMaterial: 'default',
      roofStyle: '',
      roofColor: '#3f3f3f',
      roofColorDark: '#444444',
      roofOverhang: 'none',
      oneMeter: 12,
      scaleFactor: 100,
      sectionWidth: Number,
      sectionHeight: Number,
      sectionHeightDisplay: '5.5',
      sections: {
        front: [],
        left: [],
        rear: [],
        right: []
      },
      shareurl: '',
      currentPanel: '',
      specificationHtml: '',
      squareMeters: 0,
      palette: [
        {
          color: '#58585a',
          shadedColor: '#3e3e40',
          name: 'Antracitgrå RAL 7016'
        },
        {
          color: '#c5c7c4',
          shadedColor: '#abadaa',
          name: 'Ljusgrå RAL 7035'
        },
        {
          color: '#babec7',
          shadedColor: '#a1a5ad',
          name: 'Ljus silver RAL 9006'
        },
        {
          color: '#a0a0a0',
          shadedColor: '#878787',
          name: 'Mörk silver RAL 9007'
        },
        {
          color: '#004f7c',
          shadedColor: '#003f63',
          name: 'Blå RAL 5010'
        },
        {
          color: '#f6f3e3',
          shadedColor: '#dbd9ca',
          name: 'Vit RAL 9010'
        },
        {
          color: '#d7d5cb',
          shadedColor: '#bdbbb1',
          name: 'Gråvit RAL 9002'
        },
        {
          color: '#e6d2b5',
          shadedColor: '#ccbba1',
          name: 'Ljusbeige RAL 1015'
        },
        
        /*
        {
          color: '#00557b',
          shadedColor: '#004261',
          name: 'Blå 558/RAL 5009'
        },
        {
          color: '#94282c',
          shadedColor: '#7a2124',
          name: 'Röd 758/RAL 3009'
        },
        {
          color: '#583c2c',
          shadedColor: '#402c20',
          name: 'Chokladbrun 434/RAL8017'
        },
        {
          color: '#466a44',
          shadedColor: '#365234',
          name: 'Skogsgrön 874/NCS S 6020-G30Y'
        },
        {
          color: '#3f3e40',
          shadedColor: '#262526',
          name: 'Blyertsgrå 036'
        },

        {
          color: '#0f0f0f',
          shadedColor: '#010101',
          name: 'Svart 015/RAL 9005'
        },
        {
          color: '#d3d1c1',
          shadedColor: '#bab8a9',
          name: 'Gråvit 022/RAL 7044'
        },
        */
      ],
      roofPalette: [
        '#cccccc',
        '#3f3f3f'
      ],
      baseColor: {
        color: '#f6f3e3',
        shadedColor: '#dbd9ca',
        name: 'Vit RAL 9010'
      },
      complementaryColor: {
        color: '#f6f3e3',
        shadedColor: '#dbd9ca',
        name: 'Vit RAL 9010'
      },
    }
  },
  methods: {
    activate(){
      this.activated = true;
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
    importJsonString(){
      var importJson = JSON.parse( this.jsonStringInput );
      this.calculationId = importJson.calculationid;
      this.gableSize = importJson.globaldata.gableSize;
      this.baseColor = importJson.globaldata.baseColor;
      this.complementaryColor = importJson.globaldata.complementaryColor;
      this.roofColor = importJson.globaldata.roofColor;
      this.sections = importJson.sectiondata;
      this.roofOverhang = importJson.globaldata.roofOverhang;
      this.baseMaterial = importJson.globaldata.baseMaterial;
      
      let self = this;
      self.setZoom(); 

      this.viewport = 'loading';
      setTimeout(function(){
        self.viewport = 'front';
      }, 1);
    },
    getJson(){
      return JSON.stringify(this.sections);
    },
    highlightSection(section){
      var id = section.side +'-'+ section.id;
      document.getElementById( id ).classList.add('highlight');
    },
    dimSection(section){
      var id = section.side +'-'+ section.id;
      document.getElementById( id ).classList.remove('highlight');
    },
    setGableStyle(){
      this.gableStyle = {
        width: this.oneMeter * this.gableSize + 'px',
        height: this.oneMeter * 5.5 + 'px'
      }
    },
    getRoofLength(){
      let roofLength = this.sectionWidth * this.sections.front.length;
      return roofLength;
    },
    setRoofStyle(){
      this.roofStyle = {
        width: this.getRoofLength() + 'px',
        height: this.oneMeter * this.gableSize + 'px',
        bottom: this.oneMeter * this.sectionHeightDisplay + 'px',
      }
    },
    sendByEmail(){
      let self = this;
      let request_url = process.env.VUE_APP_API_URL + '/send';

      axios.post(request_url, {
        email: self.recipientEmail,
        url: process.env.VUE_APP_URL,
        calculation_id: this.calculationId
      },{
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(function (){
        self.recipientEmail = 'Skickat!';
        setTimeout(function(){
          self.recipientEmail = '';
        }, 4000);
      })
      .catch(function(){
      })
      .then(function(){
        
      });
    },
    sendQuoteRequest(){
      let self = this;
      let request_url = process.env.VUE_APP_API_URL + '/quote';

      axios.post(request_url, {
        email: self.quoteRecipientEmail,
        phone: self.quoteRecipientPhone,
        comment: self.quoteComment,
        quote: self.specificationHtml,
        url: process.env.VUE_APP_URL,
        calculation_id: this.calculationId
      },{
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(function (){
        self.quoteRecipientEmail = 'Skickat!';
        self.quoteRecipientPhone = '';
        self.quoteComment = '';
        setTimeout(function(){
          self.quoteRecipientEmail = '';
        }, 4000);
      })
      .catch(function(){
      })
      .then(function(){
        
      });
    },
    getNextId(side){
      if( this.sections[side].length === 0 ){
        return 1;
      }
      return this.sections[side].slice(-1)[0].id + 1;
    },
    addGableSection(){
      if( this.sections.left.length === 2 ){
        this.gableSize = 18;
        this.setGableStyle();
        this.setZoom();
        this.sectionHeightDisplay = '6.6';
      }
      if( this.sections.left.length === 3 ){
        this.sectionHeightDisplay = '5.5';
        return;
      }
        
      this.sections.left.push(
        {
          id: this.getNextId('left'),
          increment: 0,
          side: 'left',
          windowTopCount: 0,
          windowTopOpenableCount: 0,
          windowBottomCount: 0,
          windowBottomOpenableCount: 0,
          door: 'none',
          gate: 'none',
          gateOption: 'flat',
          gateColor: {
            color: '#babec7',
            shadedColor: '#a1a5ad',
            name: 'Silver 045/RAL 9006'
          },
          color: '',
          complementaryColor: '',
          levelCount: 0,
          innerWall: 'none',
          seeThrough: false,
          highlight: false
        }
      );
      this.sections.right.push(
        {
          id: this.getNextId('right'),
          increment: 0,
          side: 'right',
          windowTopCount: 0,
          windowTopOpenableCount: 0,
          windowBottomCount: 0,
          windowBottomOpenableCount: 0,
          door: 'none',
          gate: 'none',
          gateOption: 'flat',
          gateColor: {
            color: '#babec7',
            shadedColor: '#a1a5ad',
            name: 'Silver 045/RAL 9006'
          },
          color: '',
          complementaryColor: '',
          levelCount: 0,
          innerWall: 'none',
          seeThrough: false,
          highlight: false
        }
      );
      this.setZoom();
    },
    addSection(){
      this.sections.front.push(
        {
          id: this.getNextId('front'),
          increment: 0,
          side: 'front',
          windowTopCount: 0,
          windowTopOpenableCount: 0,
          windowBottomCount: 0,
          windowBottomOpenableCount: 0,
          door: 'none',
          gate: 'none',
          gateOption: 'flat',
          gateColor: {
            color: '#babec7',
            shadedColor: '#a1a5ad',
            name: 'Silver 045/RAL 9006'
          },
          color: '',
          complementaryColor: '',
          levelCount: 0,
          innerWall: 'none',
          seeThrough: false,
          highlight: false
        }
      );
      this.sections.rear.push(
        {
          id: this.getNextId('rear'),
          increment: 0,
          side: 'rear',
          windowTopCount: 0,
          windowTopOpenableCount: 0,
          windowBottomCount: 0,
          windowBottomOpenableCount: 0,
          door: 'none',
          gate: 'none',
          gateOption: 'flat',
          gateColor: {
            color: '#babec7',
            shadedColor: '#a1a5ad',
            name: 'Silver 045/RAL 9006'
          },
          color: '',
          complementaryColor: '',
          levelCount: 0,
          innerWall: 'none',
          seeThrough: false,
          highlight: false
        }
      );
      this.setZoom();
    },
    setZoom(){
      if( this.sections.front.length <= 8 && this.sections.front.length > 5 ){
        this.setScale(100);
      }
      if( this.sections.front.length <= 5 ){
        this.setScale(75);
      }
      if( this.sections.front.length > 8 ){
        this.setScale(125);
      }
      if( this.sections.left.length > 2 && this.sections.front.length < 8 ){
        this.setScale(100);
      }
    },
    calculate(){
      if( this.activated === false ){
        this.activated = true;
        return
      }
      if( this.cooldown === true ){
        return;
      }

      this.cooldown = true;
      let self = this;
      setTimeout(function(){
        self.cooldown = false;
      }, 250);

      let request_url = process.env.VUE_APP_API_URL + '/calculate';

      var globaldata = {
        gableSize: this.gableSize,
        baseColor: this.baseColor,
        complementaryColor: this.complementaryColor,
        roofColor: this.roofColor,
        roofOverhang: this.roofOverhang,
        baseMaterial: this.baseMaterial,
      };

      axios.post(request_url, {
        calculationid: self.calculationId,
        globaldata: globaldata,
        sectiondata: self.sections
      },{
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(function (response){
        self.calculatedTotal = response.data.total;
        self.squareMeters = response.data.internalSquareMeters;
        self.specificationHtml = response.data.specification.html;
        if( self.calculationId === false ){
          self.$router.push('?h=' + response.data.id );
        }
        self.calculationId = response.data.id;

        self.jsonSummary = JSON.stringify( {
          calculationid: self.calculationId,
          globaldata: globaldata,
          sectiondata: self.sections
        });
      })
      .catch(function(){
      })
      .then(function(){
        
      });
    },
    removeSection(section){
      var i = 0;
      var iLen;
      
      if( section.side === 'rear' || section.side === 'front' ){
        if( this.sections.front.length === 3 ){
          return;
        }
        for (i=0, iLen=this.sections.front.length; i<iLen; i++) {
          if (this.sections.front[i].id == section.id) {
            this.sections.front.splice( i, 1 ); 
            this.sections.rear.splice( i, 1 ); 
            this.setZoom();

            return;
          }
        }
      }

      if( this.sections.right.length === 3 && ( section.side === 'right' || section.side === 'left' ) ){
        for (i=0, iLen=this.sections.left.length; i<iLen; i++) {
          if (this.sections.left[i].id == section.id) {
            this.sections.left.splice( i, 1 ); 
            this.sections.right.splice( i, 1 ); 

            this.gableSize = 12;
            this.setZoom();
            return;
          }
        }
      }
    },
    setScale(scaleFactor){
      this.scaleFactor = scaleFactor;
      //48px = 6m | 1m = 8px
      this.oneMeter = window.innerWidth / scaleFactor;
      if( window.innerWidth < 800 ) {
        this.oneMeter = window.innerWidth * 1.4 / scaleFactor;
      }
      this.sectionWidth = parseInt( this.oneMeter * 6);
      if( this.gableSize == 12 ){
        this.sectionHeight = parseInt( this.oneMeter * 5.5);
      } else {
        this.sectionHeight = parseInt( this.oneMeter * 6.6);
      }
      
      this.setRoofStyle();
      this.setGableStyle();
    },
    setIncrements(){
      var i = 1;
      this.sections.front.forEach(function(e){
        e.increment = i;
        i++;
      });

      i = 1;
      this.sections.rear.slice().reverse().forEach(function(e){
        e.increment = i;
        i++;
      });
    },
  },
  mixins: [
    VueMixinTween('calculatedTotal', 125, (pos) => pos),
    VueMixinTween('squareMeters', 125, (pos) => pos)
  ],
  mounted: function(){
    let self = this;
    var load_id = this.$route.query.h;
    if( typeof( load_id ) !== 'undefined' ){
      self.calculationId = load_id;

      let request_url = process.env.VUE_APP_API_URL + '/load/' + load_id;
      axios.get(request_url).then(function (response){
        self.jsonStringInput = response.data.json;
        self.importJsonString();
        self.activated = true;
      })
      .catch(function(){
      })
      .then(function(){
        self.activate();
      });
    }
    
    this.setScale(100);
    this.setRoofStyle();
    this.setGableStyle();

    this.addSection();
    this.addSection();
    this.addSection();

    this.addGableSection();
    this.addGableSection();
    this.setIncrements();

    window.onresize = function(){
      self.setZoom();
    };

  },
  computed: {
    cssVars() {
      let cssObj = {
        '--section-base-color': this.baseColor.color,
        '--section-base-border': this.baseColor.color,
        '--section-base-color-shaded': this.baseColor.shadedColor,
        '--section-complementary-color': this.complementaryColor.color,
        '--section-complementary-border': this.complementaryColor.color,
        '--section-complementary-color-shaded': this.complementaryColor.shadedColor,
        '--roof-base-color': this.roofColor,
        '--roof-border-color': this.roofColorDark,
        '--stripe-bottom-offset': this.oneMeter * 3.3 + 'px',
        '--stripe-height': this.oneMeter * 1.1 + 'px',
        '--window-height': this.oneMeter * 1.1 + 'px',
        '--window-width': this.oneMeter * 1.1 + 'px',
        '--window-lower-bottom-offset': this.oneMeter * 1 + 'px',
        '--window-upper-bottom-offset': this.oneMeter * 3.65 + 'px',
        '--door-height': this.oneMeter * 2.1 + 'px',
        '--door-width': this.oneMeter * 1 + 'px',
        '--gate-height': ( this.oneMeter * 4.4 ) + 1 + 'px',
        '--gate-width': this.oneMeter * 4 + 'px',
        '--level-bottom-offset': this.oneMeter * 2.5 + 'px',
        '--foregroundColor': '#3b4d56',
        '--roofOverhang': this.oneMeter * 0.5 + 'px',
        '--roofOverhangRetraction': this.oneMeter * -0.25 + 'px'
      }

      if( this.mainBg === 'grass' ){
        cssObj.background = 'url("grass.jpg")';
        cssObj['--foregroundColor'] = '#ffffff';
      }

      if( this.mainBg === 'tarmac' ){
        cssObj.background = 'url("tarmac.png")';
        cssObj['--foregroundColor'] = '#ffffff';
      }

      return cssObj;
    }
  },
  watch: {
    calculationId: function(){
      let url = process.env.VUE_APP_URL + '/#/?h=' + this.calculationId;
      this.shareurl = url;
    },
    roofColor: function(){
      this.calculate();
    },
    roofOverhang: function(){
      this.calculate();
    },
    baseColor: function(){
      this.calculate();
    },
    baseMaterial: function(){
      this.calculate();
    },
    complementaryColor: function(){
      this.calculate();
    },
    gableSize: function(){
      this.setGableStyle();
      this.calculate();
      if( this.gableSize == 12 ){
        this.sectionHeight = parseInt( this.oneMeter * 5.5);
        this.sectionHeightDisplay = 5.5;
        this.minSectionCount = 3;
      }
      if( this.gableSize == 18 ){
        this.sectionHeight = parseInt( this.oneMeter * 6.6);
        this.sectionHeightDisplay = 6.6;
        this.minSectionCount = 5;
        if( this.sections.front.length == 3 ){
          this.addSection();
          this.addSection();
        }
        if( this.sections.front.length == 4 ){
          this.addSection();
        }
      }
      this.setRoofStyle();
    },
    sections: {
      handler: function(){
        this.setRoofStyle();
        this.setIncrements();


        this.calculate();
      }, 
      deep: true
    },
    oneMeter: function(){
      this.setScale(this.scaleFactor);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@mixin mobile {
  @media (max-width: 767px) {
    @content;
  }
}

@mixin mobile_landscape {
  @media (max-width: 767px) and (min-width: 540px) {
    @content;
  }
}


body {
  margin: 0;
}

.expand-enter-active, .expand-leave-active {
  transition: all 0.15s ease-out;
}

.expand-enter, .expand-leave-to {
  width: 0px !important;

  > * {
    width: 0px !important;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.15s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  margin-bottom: -20px;
}

.shift-enter-active {
  transition: transform 0.25s 0.25s linear;
}
.shift-leave-active {
  transition: transform 0.25s linear;
}

.shift-leave-to {
  transform: rotateY(90deg);
}
.shift-enter {
  transform: rotateY(-90deg);
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.15s ease-out;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.fadeup-enter-active, .fadeup-leave-active {
  transition: all 0.15s ease-out;
}

.fadeup-enter, .fadeup-leave-to {
  transform: translateY(20px) scale(0.95);
  opacity: 0;
}

#hallbuilder {
  transition: all 0.25s;
  height: 100vh;

  &:before {
    display: none;
    position: absolute;
    top: 20px;
    right: 20px;
    content: '';
    width: 100px;
    height: 100px;
    background: url('../../public/act-logo-byline.svg') top right no-repeat;
    background-size: contain;
    z-index: 0;

    @include mobile {
      background-size: 20vw;
      background-position: 75vw 42px;
    }
  }

  #activate {
    display: none;
  }

  &.inactive {
    > * {
      opacity: 0
    }
    > #activate {
      opacity: 1;
      display: inline-block;
      position: fixed;
      top: 50vh;
      left: 50vw;
      transform: translateY(-50%) translateX(-50%);
      z-index: 500;
    }
  }
  
}


p {
  &.small {
    font-size: 0.8em;
  }
}

.viewport-switcher {
  position: absolute;
  top: 15px;
  left: 40vw;
  right: 40vw;
  text-align: center;
  z-index: 6;

  @include mobile {
    left: 5vw;
    right: auto;
    top: 50px;
  }

  @include mobile_landscape {
    top: 10px;
  }

  button {
    border: 1px solid #daa900;
    background: #daa900;

    @include mobile {
      padding: 2px 5px;
    }
  }

  button.not-active {
    background: transparent;
    border: 1px solid var(--foregroundColor);;
    color: var(--foregroundColor);
  }
}

.next-steps-panel {
  position: fixed;
  bottom: 0px;
  right: 0px;
  padding: 6px 10px;
  font-size: 1.2rem;
  z-index: 150;

  @include mobile {
    background: transparent;
    padding-top: 0px;
    padding-bottom: 0px;
    bottom: auto;
    top: 0px;
    border-bottom: 1px solid #3b4d56;
    display: flex;
    justify-content: center;
    left: 0px;
  }

  button {
    @include mobile {
      border: 0px !important;
    }
    
    &:focus {
      border: 1px solid #3b4d56;
      outline: none;
    }
  }
}

.next-step-panel {
  position: fixed;
  bottom: 0px;
  right: 0px;
  padding: 10px;
  font-size: 1.2rem;
  border-top: 1px solid #3b4d56;
  border-left: 1px solid #3b4d56;
  z-index: 200;
  background: #fff;
  min-width: 200px;

  @include mobile {
    top: 0px;
    left: 0px;
    bottom: auto;
    border-top: none;
    border-bottom: 1px solid #3b4d56;
  }

  label, h3 {
    cursor: pointer;
    margin: 0;

    @include mobile {
      font-size: 16px;
    }

    button.close {
      padding: 8px;
      line-height: 1em;
      float: right;
      background: url('../../public/icon-x-orange.png') center center no-repeat;
      background-size: contain;
    }
  }

  label {
    display: block;
  }
}

.share-panel {
  input {
    display: block;
    width:240px;
    font-size: 0.8rem;
    padding: 0.25em;
    -webkit-appearance: none;
    border-radius: 0px;
    border: 1px solid #ebebeb;
    font-family: 'Saira Condensed', sans-serif;

    @include mobile {
      width: 200px;
    }

    &:focus {
      outline: 1px solid #daa900;
    }
  }

  .relative {
    position: relative;
    display: block;

    button {
      position: absolute;
      right: 0px;
      top: 0px;
      bottom: 0px;
      padding: 0 0.45em;
      margin: 0;
      background: #daa900;
      border: none;
      font-size: 0.9rem;
      text-transform: uppercase;
    }
  }
}

.quote-panel {
  input, textarea {
    display: block;
    width:240px;
    font-size: 0.8rem;
    padding: 0.25em;
    margin-bottom: 0.5em;
    -webkit-appearance: none;
    border-radius: 0px;
    border: 1px solid #ebebeb;
    font-family: 'Saira Condensed', sans-serif;

    @include mobile {
      width: 200px;
    }

    &:focus {
      outline: 1px solid #daa900;
    }
  }

  textarea {
    min-height: 3.6em;
  }

  .relative {
    position: relative;
    display: block;

    button {
      padding: 0 0.45em;
      margin: 0;
      background: #daa900;
      border: none;
      font-size: 0.9rem;
      text-transform: uppercase;
      float: right;
    }
  }
}

.contact-panel {
  a {
    color: #3f3f3f;

    &.phone {
      text-decoration: none;
    }
  }
}

.spec-panel {
  position: absolute;
  bottom: 50px;
  left: 50vw;
  transform: translateX(-50%);
  font-size: 2.1vw;
  color: var(--foregroundColor);
  font-weight: 700;
  text-align: center;

  @include mobile {
    font-size: 16px;
    bottom: 130px;
  }

  p {
    margin: 0;
  }
}

.price-output {
}

.icon-plus {
  font-size: 0px;
  width: 27px;
  height: 27px;
  padding: 0;
  display: inline-block;
  line-height: 20px;
  padding: 5px;
  border: 1px solid #3b4d56;
  span {
    display: block;
    width: 15px;
    height: 15px;
    background: url('../../public/icon-plus.png') center center no-repeat;
    background-size: contain;
  }
}

button {
  background: #fff;
  cursor: pointer;
  color: #3b4d56;
  border: none;
  font-weight: 700;
  padding: 4px 10px;
  border: 1px solid #3b4d56;
  margin: 0 2px 5px 0;
  font-weight: 400;
  font-size: 19px;
  text-align: left;

  @include mobile {
    font-size: 15px;
  }

  &:focus {
    border: 1px solid #daa900;
    outline: none;
  }

  &.fullwidth {
    width: 100%;
  }

  &.uppercase {
    text-transform: uppercase;
  }

  &.selected {
    background: #3b4d56;
    background: #daa900;
    border: 1px solid #daa900;
  }

  &.padded {
    padding: 20px;
    margin: 0 5px 5px 0;
  }
}

.viewport {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: hidden;
}

.hall {
  width: auto;
  height: 90vh;
  margin: auto;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: skewY(-22.5deg) translateX(10vw) translateY(10%);
  position: relative;

  @include mobile {
    height: 50vh;
  }
}

.floor {
  transform: skewX(45deg);
  transform-origin: bottom left;
  position: absolute;
  opacity: 1;
  z-index: 1;
  background: #888;
  bottom: 0vw !important;
  box-sizing: content-box;
  box-shadow: 0px 0px 25px 30px rgba(0,0,0,0.075);

  @include mobile {
    box-shadow: 0px 0px 15px 10px rgba(0,0,0,0.075);
  }
}

.roof, .front, .section, .floor {
  transition: all 0.25s ease-out;
}

.roof-inner, .panel {
  transition: all 0.25s;
  // outline: 0px solid var(--section-base-border);
}
.panel {
  background: var(--section-base-color);
}

.panel .stripe {
  background: var(--section-complementary-color);
}

.roof {
  border-left: 1px solid rgba(0,0,0,0.1);

  .seam {
    width: 1px;
    height: 1px;
    position: absolute;
    left: 0px;
    transform: rotateZ(45deg);

    &.seam-1 {
      top: 50%;
    }
    &.seam-2 {
      top: 66.6%;
    }
    &.seam-3 {
      top: 33.3%;
    }

    .seam-inner {
      position: relative;

      &:before {
        content: "";
        position: absolute;
        width: 1.2%;
        bottom: 0px;
        height: 40px;
        opacity: 0.5;
        z-index: 100;
        left: -1px;
        border-left: 2px solid rgba(0, 0, 0, 0.15);
      }
      
      &:after {
        content: '';
        width: 1px;
        height: 40px;
        bottom: 0px;
        right: 1px;
        transform: translateX(1px);
        position: absolute;
      }
    }
  }
}

.gable .section .panel {
  background: var(--section-base-color-shaded);
}
.gable .panel .stripe {
  background: var(--section-complementary-color-shaded);
}

.roof {
  transform: skewX(45deg) scale(1);
  transform-origin: bottom left;
  position: absolute;
  opacity: 1;
  z-index: 200;
  background: var(--section-base-color-shaded);

  .roof-inner {
    width: 100%;
    height: 100%;
    position: relative;

    &.overhang {
      width: calc( 100% + var(--roofOverhang) );
      height: calc( 100% + var(--roofOverhang) );
      margin-left: var(--roofOverhangRetraction);
      margin-top: var(--roofOverhangRetraction);
    }

    &:after, &:before {
      box-sizing: border-box;
      border: 1px solid var(--roof-border-color);
      background: var(--roof-base-color);
      background-repeat: repeat-X;
      background-size: 100px 100%;
      transition: background 0.25s;
    }

    &:after {
      position: absolute;
      width: 100%;
      height: 50%;
      top: 0px;
      left: 0px;
      right: 0px;
      content: '';
      border-bottom: 1px solid var(--roof-border-color);
      transform-origin: top left;
      transform: skewX(12deg) scaleY(0.8);
    }
    &:before {
      position: absolute;
      width: 100%;
      height: 50%;
      bottom: 1px;
      left: 0px;
      right: 0px;
      content: '';
      border-top: 1px solid var(--roof-border-color);
      transform-origin: bottom left;
      transform: skewX(-8deg) scaleY(1.2);
    }
  }
}

h3 {
  margin: 0;
  width: 100%;

  @include mobile {
    font-size: 16px;
  }

  label {
    font-weight: 700;
    text-transform: uppercase;
  }

  span.value {
    font-weight: 400 !important;
  }
}


.inputs {
  position: fixed;
  max-width: 250px;
  left: 30px;
  top: 10px;
  max-height: 90vh;
  max-height: 40px;
  transition: all 0.25s;
  overflow: hidden;
  background: rgba(255,255,255,0.95);
  padding: 0 10px 0px;

  @include mobile {
    z-index: 200;
    left: 0px;
    top: 0;
    bottom: 0;
    box-shadow: 0px 0px 32px rgba(0,0,0,0.1);
    max-width: 140px;
    padding-bottom: 0;
    padding-top: 20px;
    min-height: 40px;
    top: auto;
    bottom: 0px;
    left: 0px;
    right: 0px;
    max-width: 100%;

  }

  &[data-visible="true"]{
    max-height: 90vh;
    overflow-y: scroll;
    padding-bottom: 50px;

    @include mobile {
      max-height: 50vh;
      max-width: 100%;
      padding-bottom: 10px;
    }

    .header {
      @include mobile {
        
      }
    }

    button.open, button.close {
      transform: rotateZ(0deg);
      padding: 0 !important;

    }

    .fields, .field {
      @include mobile {
        opacity: 1;
        max-height: 200vh;
        overflow: hidden;
      }
    }
  }
  .header {
    @include mobile {
      position: fixed;
      left: 0px;
      right: 0px;
      padding: 0px 10px;
      bottom: -40px;
      transform: translateY(-100%);
      background: #fff;
      z-index: 200;
      transition: all 0.15s;
    }
  }

  .inner {
    overflow-y: scroll;
  }

  .fields, .field {
    @include mobile {
      opacity: 0;
      max-height: 0;
      overflow: hidden;
    }
  }

  h2 {
    margin-top: 5px;
    text-transform: uppercase;

    @include mobile {
      font-size: 15px;
    }
    
    span {
      position: relative;
    }
  }

  button.open, button.close {
    position: absolute;
    top: 5px;
    right: 10px;
    background: url('../../public/icon-x-orange.png') center center no-repeat;
    background-size: 80% 80%;
    border-radius: 50%;
    border: 2px solid transparent;
    font-size: 0;
    color: transparent;
    width: 30px;
    height: 30px;
    transition: all 0.25s;
    transform: rotateZ(45deg);
    padding: 0;

    @include mobile {
      width: 20px;
      height: 20px;
      top: 2px;
      right: 5px;
      z-index: 30;
      background-color: #fff;
    }

    &:hover {
      border: 2px solid #FF6720;
    }
  }

  button {
    margin: 5px;
  }

  .debug {
    max-width: 100%;
    overflow: hidden;
  }

  
}

.sections {
  display: block;
  display: flex;
  position: relative;

  .measurement {
    position: absolute;
    font-size: 1.5rem;
    font-weight: 700;
    z-index: 10;
    color: var(--foregroundColor);

    &.length {
      top: 150%;
      left: 50%;
      transform: skew(45deg) translateX(50%);
    }
    &.height {
      top: 50%;
      left: 100%;
      transform: skew(0deg) translateX(50%) translateY(-50%);
    }
  }

  .gable {
    position: absolute;
    right: 100%;
    transform: skewY(45deg);
    transform-origin: bottom right;
    // border-right: 1px solid rgba(0,0,0,0.15);
    z-index: 150;
    display: flex;

    .measurement {
      position: absolute;
      top: 150%;
      left: 25%;
      transform: translateX(-50%) skew(-45deg);
      font-size: 1.5rem;
      font-weight: 700;
    }
  }
}

.fields {
  display: flex;
  flex-direction: column;
}

.field {

  .field-content {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    border-bottom: 1px solid #3b4d56;
    margin-bottom: 20px;
    padding-bottom: 20px;

    &.borderless {
      border: none;
    }

    label {
      font-weight: 700;

      @include mobile {
        display: block;
        line-height: 1em;
      }
      
    }

    &.disabled {
      opacity: 0.25;
      position: relative;

      &:before {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        content: '';
      }
    }

    .buttons {
      display: flex;
      flex-wrap: wrap;

      &.two-cols {
        width: 100%;
        justify-content: space-between;

        span {
          width: calc( 50% - 5px);
        }
      }

      &.text-small {
        button {
          // font-size: 15px;
        }
      }

      &.align-left {
        width: 100%;
      }

      &.two-actions {

        span {
          background: #daa900;
          background: transparent;
          cursor: pointer;
          color: #fff;
          border: none;
          font-weight: 700;
          margin: 0px 0px 5px 0px;
          min-width: 100px;
          display: flex;
          justify-content: space-between;
          text-align: left;
          position: relative;


          button {
            padding-top: 0;
            padding-bottom: 0;

            &.icon-wrench {
              padding-left: 25px;
              background: url('../../public/icon-wrench.svg') 5px center no-repeat;
              background-size: 15px;

              &:hover {
                background: url('../../public/icon-wrench-orange.svg') 5px center no-repeat;
                background-size: 15px;
              }
            }
          }
        }

        button:first-child {
          margin: 0px;
          width: 100%;
        }
        button.deletes {
          margin: 0px;
          background: #3b4d56;
          color: #daa900;
          // border-left: 1px solid #3b4d56;
          font-size: 1em;
          position: absolute;
          padding: 0 5px;
          top: 0px;
          right: 0px;
          bottom: 0px;
        }
        
      }

      button {
        margin: 0.25em;
      }
    }
  }

}

@media print {
  .spec-panel {
    display: none;
  }
  .share-panel {
    display: none;
  }
  .inputs {
    display: none;
  }
  .viewport-switcher {
    display: none;
  }
  .viewport {
    display: none;
  }
  #options-panel {
    display: none !important;
  }
  #specifications-panel {
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;

    h3.handle {
      display: none !important;
    }

    .print {
      display: none;
    }

    .specifications {
    }
  }

  .print-only {
    display: block !important;
  }
}

</style>